// extracted by mini-css-extract-plugin
module.exports = {"flash-message":"FlashMessage-module__flash-message___2aXhp","message":"FlashMessage-module__message___1KWfp","close-button":"FlashMessage-module__close-button___3y_0p"};